module.exports = __webpack_public_path__ + "img/2.c0145079.webp";